import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { WithLazy } from "../with-lazy";

var DailyMotion = /*#__PURE__*/function (_React$Component) {
  _inherits(DailyMotion, _React$Component);

  var _super = /*#__PURE__*/_createSuper(DailyMotion);

  function DailyMotion(props) {
    var _this;

    _classCallCheck(this, DailyMotion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderVideo", function () {
      _this.setState({
        showVideo: true
      }, function () {
        _this.addScript();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addScript", function () {
      var _this$props$element$m = _this.props.element.metadata,
          videoId = _this$props$element$m["video-id"],
          playerId = _this$props$element$m["player-id"];
      var script = document.createElement("script");
      script.src = "https://geo.dailymotion.com/player/".concat(playerId, ".js");
      script.dataset.video = videoId;

      _this.containerRef.current.appendChild(script);
    });

    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.state = {
      showVideo: false
    };
    return _this;
  }

  _createClass(DailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.loadIframeOnClick) {
        this.addScript();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var videoId = this.props.element.metadata["video-id"];

      if (this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, !this.state.showVideo && /*#__PURE__*/React.createElement("div", {
          className: "thumbnail-wrapper"
        }, /*#__PURE__*/React.createElement("button", {
          className: "dailymotion-playBtn",
          onClick: this.renderVideo,
          "aria-label": "Play Video"
        }), /*#__PURE__*/React.createElement("img", {
          className: "dailymotion-thumbnail",
          onClick: this.renderVideo,
          src: "https://www.dailymotion.com/thumbnail/video/".concat(videoId),
          alt: "daily-motion-video"
        })), this.state.showVideo && /*#__PURE__*/React.createElement("div", {
          className: "dailymotion-embed-wrapper dm-embed-integration",
          ref: this.containerRef
        }));
      } else if (!this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dailymotion-embed-wrapper dm-embed-integration",
          ref: this.containerRef
        });
      }
    }
  }]);

  return DailyMotion;
}(React.Component);

export default function DailyMotionEmbedScript(props) {
  return /*#__PURE__*/React.createElement(WithLazy, {
    margin: "0px"
  }, function () {
    return /*#__PURE__*/React.createElement(DailyMotion, props);
  });
}